import React from "react"
import classnames from "classnames"

import styles from "./styles.module.scss"

type CardProps = {
  title: React.ReactNode
  content: React.ReactNode
  titleClass?: string
  contentClass?: string
}

const Card = ({ title, content, titleClass, contentClass }: CardProps) => {
  return (
    <div className={styles.card}>
      <div className={classnames(styles.card_title, titleClass)}>{title}</div>
      <div className={classnames(styles.card_content, contentClass)}>{content}</div>
    </div>
  )
}

export default Card
